<template>
    <div class="banner-image-area position-relative">
        <div class="container_fl">
            <div class="row align-items-center banner-width">
                <div class="col-lg-7 wow move-up">
                    <div class="banner-image__media">
                        <img src="../../assets/img/trustami/sofie.svg" class="img-fluid" alt="">
                    </div>
                </div>
                <div class="col-lg-4 wow move-up">
                    <div class="banner-image__content">
                        <div class="section-title-wrapper mb-20">
                            <h2 class="section-title font-weight--light">{{ $t("research.sofie") }}</h2>
                        </div>
                        <div class="banner-image__text section-space--mb_40">{{ $t("research.sofie_text") }}</div>
                        <h6 class="banner-image__helper-text">
                            <b-link href="/research/sofie" class="scroll hover-style-link hover-style-link--green">
                                {{ $t("research.learn_more") }}
                            </b-link>
                        </h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SofieBanner',
};
</script>
